import { Breakpoints } from './types';

export const breakpoints: Breakpoints = {
  sm: '30rem', // 480px
  md: '46rem', // 736px
  lg: '61rem', // 980px
  xl: '80rem', // 1280px
  xxl: '105rem', // 1690px
};
